import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Image } from "@chakra-ui/react";

const HeroSection = () => {
  return (
    <>
      {/* Hero Section */}
      <Box as="section" w="100%" position="relative" overflow="hidden">
        {/* Desktop Image */}
        <Image
          src="/hero-banner-text.webp" // Replace with your desktop hero image
          alt="Pentagon Home Solutions Hero"
          w="100%"
          h={{ base: "auto", md: "500px" }}
          objectFit="cover"
          display={{ base: "none", md: "block" }}
        />

        {/* Mobile Image */}
        <Image
          src="/iPhone 16 Pro - 1 (2).webp" // Replace with your mobile hero image
          alt="Pentagon Home Solutions Hero Mobile"
          w="100%"
          h="full"
          objectFit="cover"
          display={{ base: "block", md: "none" }}
        />
      </Box>
    </>
  );
};

export default HeroSection;
